/**
 * Default global application state.
 *
 * Override to add:
 * - Views
 * - Global parameters. These will be always available in `$stateParams`.
 * - Global resolves. These will be available:
 *   - In the controller of a route component, if binded, i.e.: `loggedUser: '<'`
 *   - In a transition hook, i.e.: `trans.injector().getAsync('loggedUser').then(...)`
 *
 * @namespace tmrDefaultAppState
 * @type {ngConstant}
 */
export const constant = [
  'tmrDefaultAppState',
  {
    name: 'app',
    url: '?/', // Base url with optional trailing slash.
    views: {
      sidebar: 'tmrSidebar',
    },
    params: {
      hideSidebar: null, // If true, the sidebar will be hidden in this route (user won't be able to navigate away!)
      skipLoader: null, // If true, the loader animation will not be shown.
      prevState: null, // Filled when needed by the Connection Manager.
    },
    resolve: {
      languageReady: /*@ngInject*/ TmrLanguage => TmrLanguage.init(),
      loggedUser: /*@ngInject*/ UserStorage => UserStorage.getUser(),
      /**
       * Contains AppData key/values that are loaded only once per session,
       * available as appConfiguration[key]. If you don't have access to route
       * resolves (for example in a modal preset), you can also use
       * TmrAppConfiguration.get(key) directly.
       * To customize appConfiguration, you should decorate {@link TmrAppConfiguration.valuesToResolve()}
       **/
      appConfiguration: /*@ngInject*/ (loggedUser, TmrAppConfiguration) =>
        loggedUser.id ? TmrAppConfiguration.resolve() : {},
    },
    // So ui-sref="app" and $state.go('app') redirect to front page.
    redirectTo: trans => trans.injector().get('TmrRoutes').frontPage,
  },
]
